var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-breadcrumbs',{attrs:{"divider":">","items":_vm.breadcrumbs},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return [(item.id === _vm.getSelectedWiki.id)?_c('span',[_vm._v(_vm._s(item.name))]):_c('span',{staticClass:"primary--text pointer",on:{"click":function($event){return _vm.onClick(item)}}},[_vm._v(_vm._s(item.name))])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }